module.exports = __webpack_public_path__ + "static/img/dingzhi09.ad3ce11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dingzhi09.jpg
// module id = YWXe
// module chunks = 0